import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DatePipe } from '@angular/common';

import { CookieService } from 'angular2-cookie/services/cookies.service';
import {
    DeviceConfigurerServiceSharedLibsModule,
    DeviceConfigurerServiceSharedCommonModule,
    CSRFService,
    AuthService,
    AuthServerProvider,
    AccountService,
    UserService,
    StateStorageService,
    LoginService,
    LoginModalService,
    Principal,
    HasAnyAuthorityDirective,
    DcsLoginModalComponent
} from './';

@NgModule( {
    imports: [
        DeviceConfigurerServiceSharedLibsModule,
        DeviceConfigurerServiceSharedCommonModule,
    ],
    declarations: [
        DcsLoginModalComponent,
        HasAnyAuthorityDirective
    ],
    providers: [
        CookieService,
        LoginService,
        LoginModalService,
        AccountService,
        StateStorageService,
        Principal,
        CSRFService,
        AuthServerProvider,
        AuthService,
        UserService,
        DatePipe,
    ],
    entryComponents: [ DcsLoginModalComponent ],
    exports: [
        DeviceConfigurerServiceSharedCommonModule,
        DcsLoginModalComponent,
        HasAnyAuthorityDirective,
        DatePipe
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]

} )
export class DeviceConfigurerServiceSharedModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared.module.ts